var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSick(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.971 1.172a3.999 3.999 0 010 5.657l-8.2 8.2a4 4 0 01-2.387 1.147l-3.38.374-2.297 2.3a.999.999 0 11-1.414-1.415l2.298-2.299.375-3.377a4 4 0 011.148-2.387l8.2-8.2a4 4 0 015.658 0M8.78 10.364l-1.415 1.414L9.485 13.9l1.414-1.415-2.12-2.12zm2.83-2.828L10.192 8.95l2.122 2.121 1.414-1.414-2.12-2.12zm2.827-2.829l-1.414 1.414 2.121 2.122 1.413-1.415-2.12-2.12z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSick);
export default ForwardRef;